import { useApi } from '@/shared/api/http';
import type { RequestParams } from '@/shared/model/types/http';
import type { IChatRoom, IChatMessage } from '@/entities/chat/model/types/chat';

const withCacheBuster = (params: RequestParams): RequestParams => ({
  ...params,
  _: Date.now(),
});

export const useChatService = () => {
  const api = useApi();

  const getChatsList = async (params: RequestParams = {}) => {
    return await api.get<IChatRoom[]>('chat/', {
      params: withCacheBuster(params),
    });
  };

  const getChatMessages = async (roomId: number | string, params: RequestParams = {}) => {
    return await api.get<IChatMessage[]>(`chat/${roomId}/message/`, {
      params: withCacheBuster(params),
    });
  };

  const getDetailChat = async (roomId: number | string) => {
    return await api.get<IChatRoom>(`chat/${roomId}/`, {
      params: withCacheBuster({}),
    });
  };

  return {
    getChatsList,
    getChatMessages,
    getDetailChat,
  };
};
